// Public contact address shown to producers (FAQ, error hints). Configured per environment
// (Heroku config var / .env.development) so a mailbox change never requires a code change.
const contactEmail = import.meta.env.VITE_CONTACT_EMAIL;

export default contactEmail;
